// extracted by mini-css-extract-plugin
export default {"online":"Online_online__FyHQ+","onlineLink":"Online_onlineLink__8EdU5"};